export default "__VITE_ASSET__DlJKMiST__"